import { Contactpersoon } from "@/entities/contactpersoon";

type NaamFunctieTreinProps = {
    contact: Contactpersoon;
    isLast: boolean;
};

export function NaamFunctieTrein({ contact, isLast }: NaamFunctieTreinProps) {
    return (
        <span>
            {Contactpersoon.getDisplayName(contact)}
            {!isLast && " |"}
        </span>
    );
}
